export default __webpack_public_path__ + "static/media/support-allied-jose-abuchaem.d1ad9469.png";